import { useCallback } from 'react';
import { useStorage } from './useStorage';
import { orchestrator } from '../websocket/orchestrator';
import {
  SAP_IMPORT_STORAGE_KEY,
  SapImportStatusData,
  SapImportStorageState,
} from '../websocket/domains/sap-import/sap-import.types';
import { setPendingTaskRequest } from '../websocket/domains/sap-import/sap-import.handler';
import { RfcType } from '../types';

export function useSapImportStatus(rfcType?: RfcType) {
  const state = useStorage<SapImportStorageState>(SAP_IMPORT_STORAGE_KEY) ?? {};
  const latestStatus: SapImportStatusData | null = rfcType ? (state[rfcType] ?? null) : null;

  const requestStatus = useCallback((taskId?: string) => {
    if (!taskId) return;
    const sent = orchestrator.trySend(SAP_IMPORT_STORAGE_KEY, { action: 'get_status', task_id: taskId });
    if (!sent) setPendingTaskRequest(SAP_IMPORT_STORAGE_KEY, taskId);
  }, []);

  return { latestStatus, requestStatus };
}
